import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaSearch } from 'react-icons/fa';

const AdminHistory = () => {
  const [history, setHistory] = useState([]);
  const [filteredHistory, setFilteredHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    axios
      .get('https://backend.aubattle.com/api/history/all')
      .then((res) => {
        setHistory(res.data);
        setFilteredHistory(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching admin history:', err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const filtered = history.filter(item => 
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.email && item.email.toLowerCase().includes(searchTerm.toLowerCase()))
    );
    setFilteredHistory(filtered);
  }, [searchTerm, history]);

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>All Users Match History</h2>
      
      <div style={styles.searchContainer}>
        <div style={styles.searchBox}>
          <FaSearch style={styles.searchIcon} />
          <input
            type="text"
            placeholder="Search by name or email..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={styles.searchInput}
          />
        </div>
      </div>

      {loading ? (
        <p style={styles.loading}>Loading...</p>
      ) : filteredHistory.length === 0 ? (
        <p style={styles.noData}>No match history found.</p>
      ) : (
        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead>
              <tr style={styles.tableHeaderRow}>
                <th style={styles.tableHeader}>User</th>
                <th style={styles.tableHeader}>Match Name</th>
                <th style={styles.tableHeader}>Match Date</th>
                <th style={styles.tableHeader}>Slot Number</th>
                <th style={styles.tableHeader}>Result</th>
                <th style={styles.tableHeader}>Coins Won</th>
                <th style={styles.tableHeader}>Joined At</th>
              </tr>
            </thead>
            <tbody>
              {filteredHistory.map((row, i) => (
                <tr key={i} style={i % 2 === 0 ? styles.tableRow : styles.tableRowAlt}>
                  <td style={styles.tableCell}>
                    <div style={styles.userInfo}>
                      <span>{row.name}</span>
                      {row.email && <span style={styles.userEmail}>{row.email}</span>}
                    </div>
                  </td>
                  <td style={styles.tableCell}>{row.title}</td>
                  <td style={styles.tableCell}>{new Date(row.text_time).toLocaleString()}</td>
                  <td style={styles.tableCell}>{row.slot_number}</td>
                  <td style={{ ...styles.tableCell, color: row.is_winner ? '#4CAF50' : '#F44336' }}>
                    {row.is_winner ? 'Won' : 'Lost'}
                  </td>
                  <td style={styles.tableCell}>{row.coins_won}</td>
                  <td style={styles.tableCell}>{new Date(row.joined_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: '2rem',
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
  },
  heading: {
    color: '#333',
    marginBottom: '1.5rem',
    textAlign: 'center',
  },
  searchContainer: {
    marginBottom: '1.5rem',
    display: 'flex',
    justifyContent: 'center',
  },
  searchBox: {
    position: 'relative',
    width: '100%',
    maxWidth: '500px',
  },
  searchIcon: {
    position: 'absolute',
    left: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#777',
  },
  searchInput: {
    width: '100%',
    padding: '10px 15px 10px 40px',
    borderRadius: '25px',
    border: '1px solid #ddd',
    fontSize: '16px',
    outline: 'none',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
    transition: 'all 0.3s',
    ':focus': {
      borderColor: '#4CAF50',
      boxShadow: '0 2px 10px rgba(76, 175, 80, 0.2)',
    },
  },
  tableContainer: {
    overflowX: 'auto',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  tableHeaderRow: {
    backgroundColor: '#4CAF50',
    color: 'black',
  },
  tableHeader: {
    padding: '12px 15px',
    textAlign: 'left',
    fontWeight: '600',
  },
  tableRow: {
    borderBottom: '1px solid #eee',
    ':hover': {
      backgroundColor: 'black',
    },
  },
  tableRowAlt: {
    backgroundColor: '#fafafa',
    borderBottom: '1px solid #eee',
    ':hover': {
      backgroundColor: 'black',
    },
  },
  tableCell: {
    padding: '12px 15px',
    textAlign: 'left',
    verticalAlign: 'middle',
  },
  userInfo: {
    display: 'flex',
    flexDirection: 'column',
  },
  userEmail: {
    fontSize: '0.8rem',
    color: 'black',
    marginTop: '3px',
  },
  loading: {
    textAlign: 'center',
    color: 'black',
    fontSize: '1.2rem',
  },
  noData: {
    textAlign: 'center',
    color: 'black',
    fontSize: '1.2rem',
    padding: '2rem',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
  },
  
};

export default AdminHistory;